<script setup lang="ts">
import { SitesStorageService } from "@/services/v2/sites/storage";
import { onMounted, provide } from "vue";
import { useSitesStore, useUsersStore } from "@/stores/v2";
import {  } from "@/stores/v2";

provide("appName", "Finput")

const init = async () => {
    const userStore = useUsersStore();
    userStore.setFromLocalStorage();

    if (userStore.isLoggedIn) {
        const activeSite = await SitesStorageService.getActiveSite();
        if (activeSite && activeSite.key) {
            return useSitesStore().setActiveSite(activeSite.key);
        }
    }
};

onMounted(init);
</script>

<template>
    <router-view />
</template>